var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(v){return _c('v-chip',{key:v.id,attrs:{"small":""}},[_vm._v(_vm._s(v.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }